import { createContext, useContext } from "react";
import type { KV } from "src/lib/types/ads/KV";

export type AdContextType = {
    kv?: KV[] | null;
    //refresh: () => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setKv: (newKv: any) => void;
    loadedAds: string[];
    noMatchedAds: string[];
    refresh: () => void;
    getAuId: (targetId: string) => string | null;
    registerAdUnit: (targetId: string) => void;
    unregisterAdUnit: (targetId: string) => void;
}

export const AdContext = createContext<AdContextType>({
    kv: undefined,
    //refresh: () => { },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setKv: (newKv: any) => { },
    loadedAds: [],
    noMatchedAds: [],
    refresh: () => { },
    getAuId: (targetId) => { return null; },
    registerAdUnit: (targetId) => { },
    unregisterAdUnit: (targetId) => { },


});

//#region [Other]
export function useAdContext() {
    return useContext(AdContext);
}
//#endregion